import { render, staticRenderFns } from "./FitText.vue?vue&type=template&id=bab4e75e"
import script from "./FitText.vue?vue&type=script&lang=js"
export * from "./FitText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports